import { render } from "./LearnFree.vue?vue&type=template&id=6dea82e3&scoped=true"
import script from "./LearnFree.vue?vue&type=script&lang=js"
export * from "./LearnFree.vue?vue&type=script&lang=js"

import "./LearnFree.vue?vue&type=style&index=0&id=6dea82e3&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dea82e3"]])

export default __exports__